<template>    
    <div class="box">
        <div class="relative" v-show="!initial">
            <div class="p-6">
                <slot />
            </div>

            <footer class="p-6 bg-grey-lightest border-t-2 border-grey-lighter" v-if="hasFooterSlot">
                <slot name="footer" />
            </footer>
        </div>

        <div v-if="loading" v-bind:class="{'relative': initial}">
            <div class="box__loading p-6">
                <app-loader />
            </div>
        </div>
    </div>
</template>

<script>
    import Loader from '@/components/Loader';
    export default {
        name: 'app-box',
        components: {
            'app-loader': Loader,
        },
        props: {
            loading: {
                type: Boolean, 
                required: false
            },
            initial: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            hasFooterSlot() {
                return !!this.$slots['footer'];
            },
            isEmpty() {
                return (typeof this.$slots.default != 'undefined') ? false : true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .box {
        @apply .bg-white .shadow-lg .rounded-lg;

        &__loading {
            @apply .inline-block .relative;

            left: 50%;
            transform: translateX(-50%);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Box.vue